module.exports = __webpack_public_path__ + "img/9788997798124.4ab93d2e.jpg";